var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, DropdownClose, DropdownDownArrow, GBTypography, MultiSelectDropdown, TextInput } from '@leapfinance/geebee-component-library';
import { Divider, IconButton, Popover } from '@mui/material';
import classNames from 'classnames';
import { isFalsy } from '../../../../utils/common';
import useCFFilters from './useCFFilters';
var LocationCFFilter = function (props) {
    var _a, _b;
    var _c = useCFFilters({}), stateValues = _c.stateValues, cityValues = _c.cityValues, getCityOptions = _c.getCityOptions, getStateOptions = _c.getStateOptions;
    var _d = __read(useState([]), 2), selectedCities = _d[0], setSelectedCities = _d[1];
    var _e = __read(useState([]), 2), selectedStates = _e[0], setSelectedStates = _e[1];
    var _f = __read(useState([]), 2), availableCityOptions = _f[0], setAvailableCityOptions = _f[1];
    var _g = __read(useState([]), 2), availableStateOptions = _g[0], setAvailableStateOptions = _g[1];
    var stateOptions = useMemo(function () { return getStateOptions(props === null || props === void 0 ? void 0 : props.stateData); }, [props === null || props === void 0 ? void 0 : props.stateData]);
    var cityOptions = useMemo(function () { return getCityOptions(props === null || props === void 0 ? void 0 : props.cityData); }, [props === null || props === void 0 ? void 0 : props.cityData]);
    var _h = __read(React.useState(null), 2), anchorEl = _h[0], setAnchorEl = _h[1];
    var open = Boolean(anchorEl);
    var id = open ? 'location-filter-popover' : undefined;
    var inputRef = useRef(null);
    // const [isStateOpen, setIsStateOpen] = useState<boolean>(false);
    // const [isCityOpen, setIsCityOpen] = useState<boolean>(false);
    useEffect(function () {
        setSelectedStates(stateValues);
    }, [stateValues]);
    useEffect(function () {
        setSelectedCities(cityValues);
    }, [cityValues]);
    useEffect(function () {
        setAvailableStateOptions(stateOptions);
    }, [stateOptions]);
    useEffect(function () {
        setAvailableCityOptions(cityOptions);
    }, [cityOptions]);
    var handleClose = function (isApplied) {
        setAnchorEl(null);
        setTimeout(function () {
            var _a;
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }, 0);
        if (!isApplied) {
            setSelectedCities(cityValues);
            setSelectedStates(stateValues);
            setAvailableCityOptions(cityOptions);
            setAvailableStateOptions(stateOptions);
        }
    };
    var handleApply = function (data) {
        var _a;
        (_a = props === null || props === void 0 ? void 0 : props.onApply) === null || _a === void 0 ? void 0 : _a.call(props, { cityIds: data.cityIds, stateIds: data.stateIds });
        handleClose(true);
    };
    var handleStateChange = function (value) {
        var _a;
        if (isFalsy(value)) {
            setSelectedStates([]);
            setAvailableCityOptions(cityOptions);
            return;
        }
        setSelectedStates(value);
        var stateIds = (_a = (value !== null && value !== void 0 ? value : [])) === null || _a === void 0 ? void 0 : _a.map(function (option) { return String(option === null || option === void 0 ? void 0 : option.id); });
        setAvailableCityOptions(cityOptions === null || cityOptions === void 0 ? void 0 : cityOptions.filter(function (option) { var _a; return stateIds.includes(String((_a = option === null || option === void 0 ? void 0 : option.meta) === null || _a === void 0 ? void 0 : _a.stateId)); }));
    };
    var handleCityChange = function (value) {
        var _a;
        if (isFalsy(value)) {
            setSelectedCities([]);
            setAvailableStateOptions(stateOptions);
            return;
        }
        // filter out state options
        var validStateOptions = [];
        (value !== null && value !== void 0 ? value : []).forEach(function (option) {
            var _a, _b;
            if (!isFalsy((_a = option === null || option === void 0 ? void 0 : option.meta) === null || _a === void 0 ? void 0 : _a.stateId)) {
                validStateOptions.push((_b = option === null || option === void 0 ? void 0 : option.meta) === null || _b === void 0 ? void 0 : _b.stateId);
            }
        });
        try {
            var setObj = new Set(validStateOptions);
            var output = Array.from(setObj);
            validStateOptions = output;
        }
        catch (error) {
            console.log('Error is getting states');
        }
        // update the states
        setAvailableStateOptions((_a = (stateOptions !== null && stateOptions !== void 0 ? stateOptions : [])) === null || _a === void 0 ? void 0 : _a.filter(function (state) { return validStateOptions.includes(String(state === null || state === void 0 ? void 0 : state.id)); }));
        setSelectedCities(value);
    };
    var clearFilters = function () {
        setSelectedCities([]);
        setSelectedStates([]);
        handleApply({ cityIds: [], stateIds: [] });
    };
    var displayValue = __spreadArray(__spreadArray([], __read((_a = (selectedStates !== null && selectedStates !== void 0 ? selectedStates : [])) === null || _a === void 0 ? void 0 : _a.map(function (o) { return o === null || o === void 0 ? void 0 : o.label; })), false), __read((_b = (selectedCities !== null && selectedCities !== void 0 ? selectedCities : [])) === null || _b === void 0 ? void 0 : _b.map(function (o) { return o === null || o === void 0 ? void 0 : o.label; })), false).join(', ');
    return (React.createElement("div", { onClick: function (event) {
            if (!anchorEl) {
                setAnchorEl(event.currentTarget);
            }
        }, "data-hasValue": displayValue },
        React.createElement(TextInput, { label: "University Location", keepDefaultLabelBehaviour: true, className: classNames('lfc-w-[190px]  lfc-transition-all '), InputLabelProps: { shrink: open || !!displayValue }, value: displayValue, size: "small", InputProps: {
                readOnly: true,
                endAdornment: (React.createElement(React.Fragment, null,
                    displayValue ? (React.createElement(IconButton, { onClick: function (event) {
                            event.stopPropagation();
                            clearFilters();
                        } },
                        React.createElement(DropdownClose, { size: "small" }))) : null,
                    React.createElement(DropdownDownArrow, { size: "small", classNames: classNames('', { 'lfc-rotate-180': open }) }))),
                sx: function (theme) {
                    var _a, _b, _c, _d, _e;
                    return displayValue && !open
                        ? {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: (_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a['200'],
                                fieldSet: {
                                    borderColor: (_b = theme.palette.primary) === null || _b === void 0 ? void 0 : _b['500']
                                },
                                ':hover': {
                                    backgroundColor: (_c = theme.palette.primary) === null || _c === void 0 ? void 0 : _c['200']
                                    // fieldSet: {
                                    //   borderColor: theme.palette.primary?.['500']
                                    // }
                                },
                                '.MuiInputAdornment-positionStart': {
                                    '.MuiTypography-root': {
                                        color: (_d = theme.palette.primary) === null || _d === void 0 ? void 0 : _d['500']
                                    }
                                },
                                input: {
                                    textOverflow: 'ellipsis',
                                    color: (_e = theme.palette.primary) === null || _e === void 0 ? void 0 : _e['500']
                                }
                            }
                        }
                        : {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: 'white'
                            }
                        };
                }
            }, type: "search", onClick: function (event) {
                if (!anchorEl) {
                    setAnchorEl(event.currentTarget);
                }
            }, inputRef: inputRef }),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: function (_event, reason) {
                handleClose();
            }, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            }, transformOrigin: { vertical: 0, horizontal: 0 }, slotProps: {
                paper: {
                    sx: { overflow: 'visible' },
                    elevation: 0
                    // onClick: (event) => {
                    //   event.stopPropagation();
                    // }
                }
                // root: {
                //   onClick: () => {
                //     if (isCityOpen || isStateOpen) {
                //       setIsCityOpen(false);
                //       setIsStateOpen(false);
                //     } else {
                //       handleClose();
                //     }
                //   }
                // }
            }, className: "lfc-mt-1 " },
            React.createElement("div", { className: "lfc-w-[380px] lfc-flex lfc-flex-col lfc-gap-3 lfc-pt-4   lfc-rounded-md lfc-border lfc-shadow-lg" },
                React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-3 lfc-px-4" },
                    React.createElement(MultiSelectDropdown
                    // open={isStateOpen}
                    // onOpen={() => {
                    //   setIsStateOpen(true);
                    // }}
                    // onClose={(_event, reason) => setIsStateOpen(false)}
                    , { 
                        // open={isStateOpen}
                        // onOpen={() => {
                        //   setIsStateOpen(true);
                        // }}
                        // onClose={(_event, reason) => setIsStateOpen(false)}
                        value: selectedStates, options: availableStateOptions !== null && availableStateOptions !== void 0 ? availableStateOptions : [], textInputProps: {
                            label: 'State',
                            placeholder: 'Select state'
                        }, renderCustomLabel: function (option) {
                            var _a;
                            return (React.createElement("div", { className: "lfc-flex lfc-items-end" },
                                React.createElement(GBTypography, { variant: "body3" }, option === null || option === void 0 ? void 0 : option.label),
                                React.createElement(GBTypography, { variant: "caption1", className: "lfc-text-gbTokens-grey-A600 lfc-ml-1" },
                                    "(", (_a = option === null || option === void 0 ? void 0 : option.count) !== null && _a !== void 0 ? _a : 0,
                                    ")")));
                        }, onChange: function (_event, values) {
                            handleStateChange(values);
                        }, getOptionKey: function (option) { return (typeof option === 'string' ? option : option === null || option === void 0 ? void 0 : option.value); }, size: "small" }),
                    React.createElement(MultiSelectDropdown
                    // open={isCityOpen}
                    // onOpen={() => {
                    //   setIsCityOpen(true);
                    // }}
                    // onClose={(_event, reason) => {
                    //   setIsCityOpen(false);
                    // }}
                    , { 
                        // open={isCityOpen}
                        // onOpen={() => {
                        //   setIsCityOpen(true);
                        // }}
                        // onClose={(_event, reason) => {
                        //   setIsCityOpen(false);
                        // }}
                        value: selectedCities, options: availableCityOptions !== null && availableCityOptions !== void 0 ? availableCityOptions : [], textInputProps: {
                            label: 'City',
                            placeholder: 'Select city'
                        }, renderCustomLabel: function (option) {
                            var _a;
                            return (React.createElement("div", { className: "lfc-flex lfc-items-end" },
                                React.createElement(GBTypography, { variant: "body3" }, option === null || option === void 0 ? void 0 : option.label),
                                React.createElement(GBTypography, { variant: "caption1", className: "lfc-text-gbTokens-grey-A600 lfc-ml-1" },
                                    "(", (_a = option === null || option === void 0 ? void 0 : option.count) !== null && _a !== void 0 ? _a : 0,
                                    ")")));
                        }, onChange: function (_event, values) {
                            handleCityChange(values);
                        }, getOptionKey: function (option) { return (typeof option === 'string' ? option : option === null || option === void 0 ? void 0 : option.value); }, size: "small" })),
                React.createElement("div", { className: "lfc-flex lfc-flex-col" },
                    React.createElement(Divider, null),
                    React.createElement("div", { className: "lfc-self-end lfc-p-2 lfc-flex lfc-gap-2" },
                        React.createElement(Button, { variant: "tertiary", onClick: function () {
                                clearFilters();
                            } }, "Clear"),
                        React.createElement(Button, { onClick: function () {
                                handleApply({ cityIds: selectedCities, stateIds: selectedStates });
                            } }, "Apply")))))));
};
export default LocationCFFilter;
//# sourceMappingURL=LocationCFFilter.js.map